import { KingpinBadgeType } from '../../../../kingpin/atoms/Badge';

// The default "excluded" tag. Records carrying this tag are dropped from the
// bonus/scoring calculation — it is the original behaviour that predates the
// generic tagging API and every exclusion config falls back to it when no tag
// is explicitly configured.
//
// NOTE: the backend (driver_bonus_api) also hardcodes this same "EXCLUDED"
// value today. They intend to stop owning it once all tags are SE-managed, so
// keep this constant in sync with the backend until that migration lands.
export const DEFAULT_EXCLUDED_TAG = 'EXCLUDED';

const DEFAULT_EXCLUDED_TAG_LABEL = 'Excluded';
const DEFAULT_EXCLUDED_TAG_COLOR: KingpinBadgeType = 'Orange';

export const DEFAULT_EXCLUDED_TAG_OPTION: BonusTags.TagOption = {
  tag: DEFAULT_EXCLUDED_TAG,
  label: DEFAULT_EXCLUDED_TAG_LABEL,
  color: DEFAULT_EXCLUDED_TAG_COLOR,
};

// Default label for the exclusion view's primary action button when the
// exclusion config does not specify a custom one.
export const DEFAULT_PRIMARY_ACTION_BUTTON_TEXT = 'Save Exclusions';

// Default label for the exclusion view's secondary action button when the
// exclusion config does not specify a custom one.
export const DEFAULT_SECONDARY_ACTION_BUTTON_TEXT = 'Delete exclusions';

// Shown on the disabled selection checkboxes / action buttons once the bonus
// period is locked (pending sign off or closed). "Active" and "Finalizing Data"
// are the user-facing labels for the 'active' and 'in review' statuses.
export const PERIOD_LOCKED_MESSAGE =
  'This is only available while the bonus period is Active or Finalizing Data.';
